export const config = {
    holidayFrom: new Date('2024-07-18T00:00:00+03:00'),
    holidayTo: new Date('2024-07-30T23:59:59+03:00'),
    workingHours: {
      start: 5.5, // 5:30 AM
      end: 22,  // PM
    },
    timezoneOffset: 3 * 60, // GMT+3 in minutes
    workingDays: [1, 2, 3, 4, 5, 6, 7], 
};

/**
 * Get the current time in the specified timezone.
 * @returns {Date}
 */
function getCurrentTimeInTimezone() {
    const now = new Date();
    const localOffset = -now.getTimezoneOffset(); // in minutes
    const targetOffset = config.timezoneOffset; // in minutes
    // console.log("Current timezone offset: ", localOffset);
    const offsetDifference = targetOffset - localOffset; // in minutes
    // return new Date('2023-10-22T22:00:00+03:00');
    return new Date(now.getTime() + offsetDifference * 60 * 1000); // Adjust time by minutes
}

/**
 * Check if the current time is within the holiday period.
 * @returns {boolean}
 */
export function isHoliday() {
    return false;
    const now = getCurrentTimeInTimezone();
    const isAfterHolidayStart = now >= config.holidayFrom;
    const isBeforeHolidayEnd = now <= config.holidayTo;
    return isAfterHolidayStart && isBeforeHolidayEnd;
}

/**
 * Check if the current time is outside working hours.
 * @returns {boolean}
 */
export function isOutsideWorkingHours() {
    return false;
    const now = getCurrentTimeInTimezone();
    let day = now.getUTCDay();
    let hour = now.getUTCHours();
    // we don't handle the day because the day doesn't matter
    const adjustedHour = (hour + config.timezoneOffset / 60) % 24;

    // return false;
    // console.log("Current hour of the day: ", adjustedHour);

    return adjustedHour < config.workingHours.start || adjustedHour >= config.workingHours.end;
}

/**
 * Check if the current time is within the holiday period or outside working hours.
 * @returns {boolean}
 */
export function isHolidayOrOutsideWorkingHours() {
    return isHoliday() || isOutsideWorkingHours();
}


/**
 * Format a time value to a string in the format "HH:MM".
 * @param {number} time - The time value to format.
 * @returns {string} The formatted time string.
 */
export const formatTime = (time) => `${Math.floor(time)}:${(time % 1) * 60 === 0 ? '00' : (time % 1) * 60}`;

/**
 * Вземете работния ден от число.
 * @param {number} dayNumber - Числото, представляващо деня (0 за неделя, 1 за понеделник, ..., 6 за събота).
 * @returns {string} Името на работния ден.
 */
export function getWorkingDayFromNumber(dayNumber) {
    const days = ['Понеделник', 'Вторник', 'Сряда', 'Четвъртък', 'Петък', 'Събота', 'Неделя'];
    console.log("Day number: ", dayNumber);
    return days[dayNumber - 1] || 'Невалиден номер на ден';
}


/**
 * Simplify a list to only include the first and last elements.
 * @param {any[]} list - The list to simplify.
 * @returns {string} The formatted string representing working days.
 */
export function formatWorkingDays(list) {
    if (list.length <= 1) {
        throw new Error('List must contain at least two elements');
    }
    const startDay = getWorkingDayFromNumber(list[0]);
    const endDay = getWorkingDayFromNumber(list[list.length - 1]);
    return `${startDay} до ${endDay}`;
}

